import {Directive, ElementRef, Input, OnInit} from '@angular/core';
import {Project} from "../models/project";
import {AuthenticationService} from "../services/authentication.service";

@Directive({
  selector: '[appAdminAccess]',
  standalone: true
})
export class AdminAccessDirective implements OnInit {
  constructor(private elementRef: ElementRef, private authenticationService: AuthenticationService) { }

  ngOnInit() {
    const result = this.authenticationService.isAdmin();
    this.setHidden(!result);
  }

  private setHidden(value: boolean) {
    this.elementRef.nativeElement.hidden = value;
  }
}
